import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import { Group, Radio } from "@mantine/core";
import AsyncSelect from "react-select/async";
import CustomDateAndTime from "../../../../../../components/customDateAndTime/CustomDateAndTime";
import { DatePicker, TimeInput } from "@mantine/dates";
import { ReactComponent as DateIcon } from "../../../../../../assets/fi-rr-calendar.svg";
import CustomButton from "../../../../../../components/CustomButton";
import CustomDOBPicker from "../../../../../../components/CustomDOBPicker";
import { useForm, Controller, useWatch } from "react-hook-form";

const OriginallyBookedFlights = ({
  setStepthree,
  onSubmit,
  flightDetails,
  setFlightDetails,
  RemoveCircleOutline,
  removeFlightDetails,
  setTriggerIndex,
  flightOptions,
  loadOptions,
  defaultAirlineOptions,
  setTriggerFrom,
  loadAirlineOptions,
  defaultOptions,
  type_of_claim,
  flightClassOptions,
}) => {
  const {
    control,
    watch,
    handleSubmit,
    formState: { errors, isValid },
    setValue: setFormValue,
    reset,
    getValues,
    trigger,
  } = useForm({
    defaultValues: {
      flight_details: [],
    },
    mode: "onChange",
  });

  // useEffect(() => {
  //   console.log(isValid);
  //   setStepthree(isValid);
  //   // if (isValid) {
  //   //   trigger()
  //   // }
  // }, [isValid]);






  // const [selectedIssue, setSelectedIssue] = useState([]);
  const watchedDisruptions =
    useWatch({
      control,
      name: "flight_details",
    })?.map((flight) => flight?.disruption) || [];


  const LOCAL_STORAGE_KEY = "OriginallyBookedFlightsData";
  const [dateError, setDateError] = useState(null);
  const [departureDateError, setDepartureDateError] = useState(null);
  console.log("32--->", flightDetails);

  // Date and time validation functions

  // useEffect(() => {
  //   if (flightDetails && flightDetails.length > 0) {
  //   const allDetailsHave = flightDetails.every((flight)=> flight.airline !== '' && flight.flight_number !== '' && flight.airport_of_origin !== ''&& flight.airport_of_destination !== ''&& flight.date_of_travel !== ''&& flight.original_departure_time !== ''&& flight.original_arrival_time !== ''&& flight.original_departure_date !== ''&& flight.flight_class !== '')

  //     if (allDetailsHave) {
  //       trigger()
  //     }

  //   }
  // }, [])


  useEffect(() => {
    if (flightDetails && flightDetails.length > 0) {
      console.log(flightDetails)
      const allDetailsHave = flightDetails.every((flight) => flight.airline !== '' && flight.flight_number !== '' && flight.airport_of_origin !== '' && flight.airport_of_destination !== '' && flight.date_of_travel !== '' && flight.original_departure_time !== '' && flight.original_arrival_time !== '' && flight.original_arrival_date !== '' && flight.original_departure_date !== '' && flight.flight_class !== '')

      if (allDetailsHave) {
        setStepthree(true)

      } else {
        setStepthree(false)
      }

    }
  }, [flightDetails])

  const validateDates = (
    departureDate,
    departureTime,
    arrivalDate,
    arrivalTime
  ) => {
    if (!departureDate || !arrivalDate) return true;

    const departure = new Date(`${departureDate}T${departureTime || "00:00"}`);
    const arrival = new Date(`${arrivalDate}T${arrivalTime || "00:00"}`);

    return arrival >= departure;
  };

  const validateTimes = (departureTime, arrivalTime) => {
    if (!departureTime || !arrivalTime) return true;

    const [depHours, depMins] = departureTime.split(":").map(Number);
    const [arrHours, arrMins] = arrivalTime.split(":").map(Number);

    return arrHours > depHours || (arrHours === depHours && arrMins > depMins);
  };




  const typingTimeouts = useRef({});

  // cleanup on unmount
  useEffect(() => {
    return () => {
      Object.values(typingTimeouts.current).forEach((t) => clearTimeout(t));
    };
  }, []);

  const DEBOUNCE_MS = 600; // change delay as needed



  const handleDisruptionChange = (index, value, fieldOnChange) => {
    fieldOnChange(value);

    setFlightDetails((prevState) => {
      const updated = [...prevState];
      updated[index] = {
        ...updated[index],
        disruption: value,
        delayed: value === "delayed",
        cancelled: value === "cancelled",
        missed: value === "missed",
        denied: value === "denied",
        downgraded: value === "downgraded",
        delay_duration: value === "delayed" ? updated[index]?.delay_duration : null,
        cancellation_info_at_airport: value === "cancelled" ? updated[index]?.cancellation_info_at_airport : false,
        cancellation_info_before: value === "cancelled" ? updated[index]?.cancellation_info_before : false,
        missed_due_to_error: value === "missed" ? updated[index]?.missed_due_to_error : false,
        missed_due_to_personal: value === "missed" ? updated[index]?.missed_due_to_personal : false,
        missed_none: value === "missed" ? updated[index]?.missed_due_to_personal : false,
        cancellation_none: value === "cancelled" ? updated[index]?.missed_due_to_personal : false,

      };
      return updated;
    });
  };

  const handleCancellationonChange = (index, value, fieldOnChange) => {
    // console.log("Selected issue:", value);

    // Update React Hook Form's state
    fieldOnChange(value);

    // Update flight details state
    setFlightDetails((prevState) => {
      const updatedFlightDetails = [...prevState];
      updatedFlightDetails[index] = {
        ...updatedFlightDetails[index],
        cancellation_info_at_airport: value === "cancellation_info_at_airport",
        cancellation_info_before: value === "cancellation_info_before",
        cancellation_none: value === "none"
      };
      return updatedFlightDetails;
    });
  };

  const handleMissedonChange = (index, value, fieldOnChange) => {
    // console.log("Selected issue:", value);

    // Update React Hook Form's state
    fieldOnChange(value);

    // Update flight details state
    setFlightDetails((prevState) => {
      const updatedFlightDetails = [...prevState];
      updatedFlightDetails[index] = {
        ...updatedFlightDetails[index],
        missed_due_to_error: value === "missed_due_to_error",
        missed_due_to_personal: value === "missed_due_to_personal",
        missed_none: value === "none"
      };
      return updatedFlightDetails;
    });
  };

  const handleDelayedonChange = (index, value, fieldOnChange) => {
    // console.log("Selected issue:", value);

    // Update React Hook Form's state
    fieldOnChange(value);

    // Update flight details state
    setFlightDetails((prevState) => {
      const updatedFlightDetails = [...prevState];
      updatedFlightDetails[index] = {
        ...updatedFlightDetails[index],
        delay_duration: value,
      };
      return updatedFlightDetails;
    });
  };

  const setManualEntryIndex = (index) => {
    const updatedFlightDetails = [...flightDetails];
    updatedFlightDetails[index].manual = true;
    setFlightDetails(updatedFlightDetails);
  }

  // Load initial data from localStorage or props
  useEffect(() => {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);

        // Only use localStorage data if no flightDetails passed from parent
        if (!flightDetails || flightDetails.length === 0) {
          setFlightDetails(parsedData.flightDetails);
          // reset({ flight_details: parsedData.formValues });
          // setSelectedIssue(parsedData.selectedIssues || []);
          // Initialize form with all values including sub-options
          const initialValues = parsedData.flightDetails.map((flight) => ({
            // ... other fields
            disruption: flight.delayed
              ? "delayed"
              : flight.cancelled
                ? "cancelled"
                : flight.missed
                  ? "missed"
                  : flight.disruption,
            delay_duration: flight.delay_duration,
            flight_cancel: flight.cancellation_info_before
              ? "cancellation_info_before"
              : flight.cancellation_info_at_airport
                ? "cancellation_info_at_airport" : flight.cancellation_none
                  ? "none"
                  : "",
            missed_connection: flight.missed_due_to_error
              ? "missed_due_to_error"
              : flight.missed_due_to_personal
                ? "missed_due_to_personal" : flight.missed_none
                  ? "none"
                  : "",
            flight_class: flight.flight_class,
          }));

          reset({ flight_details: initialValues });
        }
        // Explicitly set all sub-option form values
        parsedData.flightDetails?.forEach((flight, index) => {
          if (flight.disruption === "cancelled") {
            setFormValue(
              `flight_details[${index}].flight_cancel`,
              flight.cancellation_info_before
                ? "cancellation_info_before"
                : flight.cancellation_info_at_airport
                  ? "cancellation_info_at_airport" : flight.cancellation_none
                    ? "none"
                    : ""
            );
          } else if (flight.disruption === "delayed") {
            setFormValue(
              `flight_details[${index}].delay_duration`,
              flight.delay_duration
            );
          } else if (flight.disruption === "missed") {
            setFormValue(
              `flight_details[${index}].missed_connection`,
              flight.missed_due_to_error
                ? "missed_due_to_error"
                : flight.missed_due_to_personal
                  ? "missed_due_to_personal" : flight.missed_none
                    ? "none"
                    : ""
            );
          }
        });
      } catch (error) {
        // console.error("Error parsing localStorage data:", error);
      }
    } else if (flightDetails && flightDetails.length > 0) {
      // Initialize form with flightDetails from props
      console.log("calling")
      reset({
        flight_details: flightDetails.map((flight) => ({
          Airline: flight.airline,
          flight_number: flight.flight_number,
          airport_of_origin: flight.airport_of_origin,
          airport_of_destination: flight.airport_of_destination,
          date_of_travel: flight.date_of_travel,
          original_departure_time: flight.original_departure_time,
          original_departure_date: flight.original_departure_date,
          original_arrival_date: flight.original_arrival_date,
          original_arrival_time: flight.original_arrival_time,
          ticket_ref_no: flight.ticket_ref_no,
          flight_class: flight.flight_class,
          disruption: flight.delayed
            ? "delayed"
            : flight.cancelled
              ? "cancelled"
              : flight.missed
                ? "missed" : flight.denied
                  ? "denied" : flight.downgraded
                    ? "downgraded"
                    : flight.disruption,
          delay_duration: flight.delay_duration,
          flight_cancel: flight.flight_cancel,
          missed_connection: flight.missed_connection,
          // claim_details: flight.claim_details,
          additional_details: flight.additional_details,
          delayed: flight.delayed,
          cancelled: flight.cancelled,
          missed: flight.missed,
          denied: flight.denied,
          downgraded: flight.downgraded,
          cancellation_info_before: flight.cancellation_info_before,
          cancellation_info_at_airport: flight.cancellation_info_at_airport,
          cancellation_none: flight.cancellation_none,
          missed_due_to_error: flight.missed_due_to_error,
          missed_none: flight.missed_none,
          missed_due_to_personal: flight.missed_due_to_personal,
          delay_duration_minutes: flight.delay_duration_minutes || 0,
        })),
      });

      trigger();
    }
  }, []);

  // Save data to localStorage whenever it changes
  useEffect(() => {
    const formData = getValues();
    const dataToSave = {
      formValues: formData,
      flightDetails: flightDetails,
      // selectedIssues: selectedIssue,
    };

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToSave));
  }, [flightDetails, getValues]);

  const parseDMY = (dateStr) => {
    if (dateStr == null || dateStr === undefined || dateStr === "")
      return false;
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split("-");
      return new Date(`${year}-${month}-${day}`);
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-");
      return new Date(`${year}-${month}-${day}`);
    }

    return dateStr;
  };

  // Sync form values with flightDetails changes
  useEffect(() => {
    flightDetails.forEach((flight, index) => {
      setFormValue(`flight_details[${index}].Airline`, flight.airline);
      setFormValue(
        `flight_details[${index}].flight_number`,
        flight.flight_number
      );
      setFormValue(
        `flight_details[${index}].airport_of_origin`,
        flight.airport_of_origin
      );
      setFormValue(
        `flight_details[${index}].airport_of_destination`,
        flight.airport_of_destination
      );
      setFormValue(
        `flight_details[${index}].date_of_travel`,
        flight.date_of_travel
      );
      setFormValue(
        `flight_details[${index}].original_departure_time`,
        flight.original_departure_time
      );
      setFormValue(
        `flight_details[${index}].original_arrival_date`,
        flight.original_arrival_date
      );
      setFormValue(
        `flight_details[${index}].original_arrival_time`,
        flight.original_arrival_time
      );
      setFormValue(
        `flight_details[${index}].ticket_ref_no`,
        flight.ticket_ref_no
      );
      setFormValue(`flight_details[${index}].disruption`, flight.disruption);
      setFormValue(
        `flight_details[${index}].delay_duration`,
        flight.delay_duration
      );
      setFormValue(
        `flight_details[${index}].flight_cancel`,
        flight.cancellation_info_before
          ? "cancellation_info_before"
          : flight.cancellation_info_at_airport
            ? "cancellation_info_at_airport" : flight.cancellation_none ? "none"
              : ""
      );
      setFormValue(
        `flight_details[${index}].missed_connection`,
        flight.missed_due_to_error
          ? "missed_due_to_error"
          : flight.missed_due_to_personal
            ? "missed_due_to_personal" : flight.missed_none
              ? "none"
              : ""
      );
      // setFormValue(
      //   `flight_details[${index}].claim_details`,
      //   flight.claim_details
      // );
      setFormValue(
        `flight_details[${index}].additional_details`,
        flight.additional_details
      );
      setFormValue(
        `flight_details[${index}].flight_class`,
        flight.flight_class
      );
    });

    // trigger();
  }, [flightDetails, setFormValue]);

  const handleFormSubmit = (data) => {
    // Validate all flights before submission
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split("-");
      const date =
        year?.length == 4
          ? `${year}-${month}-${day}`
          : `${day}-${month}-${year}`;
      return new Date(date);
    };

    console.log("Flight Details: ================> ", data);
    // const hasInvalidDates = data.flight_details.some((flight, index) => {
    //   if (!flight.date_of_travel || !flight.original_arrival_date) return false;

    //   const isSameDate = flight.date_of_travel === flight.original_arrival_date;
    //   const dateValid =
    //     parseDate(flight.original_arrival_date) >=
    //     parseDate(flight.date_of_travel);

    //   if (isSameDate) {
    //     return !validateTimes(
    //       flight.original_departure_time,
    //       flight.original_arrival_time
    //     );
    //   }

    //   return !dateValid;
    // });

    // if (hasInvalidDates) {
    //   setDateError("One or more flights have invalid date/time combinations");
    //   return;
    // }

    // console.log("150---------->", data?.claim_details);
    // console.log("151---------->", data?.flight_details);

    const flightDetailsArray = Array.isArray(data?.flight_details)
      ? data.flight_details
      : [];

    // Merge form data with flightDetails to ensure no data loss
    const mergedData = {
      ...data,
      // flight_details: data?.flight_details?.map((flight, index) => ({
      flight_details: flightDetailsArray?.map((flight, index) => ({
        ...flight,
        // Include any additional fields from flightDetails that might be missing
        airline: flightDetails[index]?.airline || flight.Airline,
        flight_number:
          flightDetails[index]?.flight_number || flight.flight_number,
        airport_of_origin:
          flightDetails[index]?.airport_of_origin || flight.airport_of_origin,
        airport_of_destination:
          flightDetails[index]?.airport_of_destination ||
          flight.airport_of_destination,
        date_of_travel:
          flightDetails[index]?.date_of_travel || flight.date_of_travel,

        scheduled_arrival: `${flight.original_arrival_date}T${flight.original_arrival_time &&
          flight.original_arrival_time.trim() !== ""
          ? flight.original_arrival_time
          : "00:00"
          }`,
        scheduled_departure: `${flight.date_of_travel}T${flight.original_departure_time &&
          flight.original_departure_time.trim() !== ""
          ? flight.original_departure_time
          : "00:00"
          }`,

        original_arrival_time:
          flightDetails[index]?.original_arrival_time ||
          flight.original_arrival_time,
        original_departure_time:
          flightDetails[index]?.original_departure_time ||
          flight.original_departure_time,
        ticket_ref_no:
          flightDetails[index]?.ticket_ref_no || flight.ticket_ref_no,
        disruption:
          flightDetails[index]?.delayed || flight.delayed
            ? "delayed"
            : flightDetails[index]?.cancelled || flight.cancelled
              ? "cancelled"
              : flightDetails[index]?.missed || flight.missed
                ? "missed"
                : flightDetails[index]?.denied || flight.denied
                  ? "denied" :
                  flightDetails[index]?.downgraded || flight.downgraded
                    ? "downgraded"

                    : flightDetails[index]?.disruption || flight.disruption,
        delay_duration:
          flightDetails[index]?.delay_duration || flight.delay_duration,
        flight_cancel:
          flightDetails[index]?.flight_cancel || flight.flight_cancel,
        missed_connection:
          flightDetails[index]?.missed_connection || flight.missed_connection,
        // claim_details:
        //   flightDetails[index]?.claim_details || flight.claim_details,
        additional_details:
          flightDetails[index]?.additional_details || flight.additional_details,
        delayed: flightDetails[index]?.delayed || flight.delayed,
        cancelled: flightDetails[index]?.cancelled || flight.cancelled,
        denied: flightDetails[index]?.denied || flight.denied,
        downgraded: flightDetails[index]?.downgraded || flight.downgraded,
        missed: flightDetails[index]?.missed || flight.missed,
        cancellation_info_before:
          flightDetails[index]?.cancellation_info_before ||
          flight.cancellation_info_before,
        cancellation_info_at_airport:
          flightDetails[index]?.cancellation_info_at_airport ||
          flight.cancellation_info_at_airport,

        cancellation_none:
          flightDetails[index]?.cancellation_none ||
          flight.cancellation_none,
        missed_due_to_error:
          flightDetails[index]?.missed_due_to_error ||
          flight.missed_due_to_error,
        missed_none:
          flightDetails[index]?.missed_none ||
          flight.missed_none,
        missed_due_to_personal:
          flightDetails[index]?.missed_due_to_personal ||
          flight.missed_due_to_personal,

        delay_duration_minutes: flightDetails[index]?.delay_duration_minutes || 0,
      })),
    };

    // Save before submission
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({
        formValues: data,
        flightDetails: mergedData.flight_details,
        // selectedIssues: selectedIssue,
      })
    );

    setStepthree(true);
    console.log(mergedData)
    onSubmit(mergedData);
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",

      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
          ? "#f0f0f0"
          : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? "#222" : "#222",
      opacity: 1,
    }),
  };

  const dateRef = useRef(null);
  const timeRef = useRef(null);

  const [dateInputType, setDateInputType] = useState("text");
  const [timeInputType, setTimeInputType] = useState("time");
  const [dateInputType2, setDateInputType2] = useState("text");
  const [timeInputType2, setTimeInputType2] = useState("time");

  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value) || yyyymmdd.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };

  // console.log("Current form values:", getValues());
  // console.log("Flight details:", flightDetails);
  // console.log(
  //   "Saved data:",
  //   JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
  // );

  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Originally booked flights
        </h3>
      </div>

      <form onSubmit={handleSubmit(handleFormSubmit)} id="original-flight-form">
        <div>
          <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
            Provide details for the originally booked flight(s){" "}
            <span style={{ color: "#de8385" }}>*</span>

          </h4>
          <span className="stepper-sub-header" style={{ fontSize: "20px" }}>
            (Please enter all flights)
          </span>

          {
            type_of_claim === "cancelled" && <p className="note-wrapper" style={{ marginTop: "15px", padding: "10px 15px" }}>
              Note: Cancellation claim is not applicable if an alternative flight was provided by the airline.
            </p>
          }

        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
          <div className="file-a-claim">
            {flightDetails.length > 0 &&
              flightDetails.map((flight, index) => (
                <div key={index}>
                  <div className="flight-add-wrapper">
                    <h3>Flight {index + 1}</h3>
                    {flightDetails.length > 1 && (
                      <div
                        style={{
                          backgroundColor: "none",
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "2px",
                          textAlign: "right",
                        }}
                        onClick={() => removeFlightDetails(index)}
                      >
                        <RemoveCircleOutline />
                      </div>
                    )}
                  </div>

                  <div className="grid-two">
                    <div className="custom-input">

                      <label className="input-label">
                        Search by
                        {/* <span style={{ color: "#de8385" }}> *</span> */}
                      </label>

                      <Radio.Group
                        value={flight.search_by}
                        onChange={(value) => {


                          const updatedFlightDetails = [...flightDetails];
                          updatedFlightDetails[index].search_by = value;

                          setFlightDetails(updatedFlightDetails)
                        }}
                      >
                        <div className="claim-form-radio-wrapper">

                          <Radio
                            color="red"
                            // checked
                            variant="outline"
                            value={"airline_name"}
                            label="Airline name"
                            size="xs"
                          />

                          <Radio
                            color="red"
                            variant="outline"
                            value={"iata_code"}
                            label="Airline code"
                            size="xs"

                          />
                        </div>
                      </Radio.Group>
                    </div>





                  </div>
                  <div className="grid-two">
                    <div className="custom-select" style={{ width: "100%" }}>
                      {/* <div className="airline-radio-wrapper">

                        <Radio.Group
                                                      value={flight.search_by}
                          onChange={(value) => {
                                                        

                             const updatedFlightDetails = [...flightDetails];
                            updatedFlightDetails[index].search_by = value;
                            
                            setFlightDetails(updatedFlightDetails)
                                                      }}
                                                    >
                          <div className="claim-form-radio-wrapper">
                            <label className="search-by-label">Search by:</label>
                                                        <Radio
                                                          color="red"
                                                          // checked
                                                          variant="outline"
                                                          value={"airline_name"}
                              label="Airline name"
                              size="xs"
                                            />
                                            
                                                        <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"iata_code"}
                              label="Airline code"
                              size="xs"
                              
                                                        />
                                                      </div>
                                                    </Radio.Group>
                      </div> */}
                      <span className="select-label">
                        Airline <span style={{ color: "#de8385" }}> *</span>
                      </span>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                        <Controller
                          name={`flight_details[${index}].Airline`}
                          control={control}
                          rules={{ required: "Airline is required" }}
                          render={({ field }) => (
                            <AsyncSelect
                              {...field}
                              cacheOptions={false}
                              defaultOptions={defaultAirlineOptions}
                              loadOptions={(inputValue, callback) =>
                                loadAirlineOptions(inputValue, flight.search_by || "airline_name", callback)
                              }
                              value={
                                flight.airline
                                  ? {
                                    label: flight.airline,
                                    value: flight.airline,
                                  }
                                  : null
                              }
                              placeholder="Choose airline"
                              onChange={(selectedOption) => {
                                const updatedFlightDetails = [...flightDetails];
                                updatedFlightDetails[index].hub_code =
                                  selectedOption?.hub_code || "";
                                updatedFlightDetails[index].iata_code =
                                  selectedOption?.iata_code || "";
                                updatedFlightDetails[index].airline =
                                  selectedOption?.label || "";
                                setFlightDetails(updatedFlightDetails);
                                setTriggerIndex(index);
                                setTriggerFrom("original");
                                field.onChange(selectedOption?.label || "");
                                setFormValue(
                                  `flight_details[${index}].Airline`,
                                  selectedOption?.label || ""
                                );
                              }}
                              styles={selectStyles}
                            />
                          )}
                        />
                      </div>
                      {errors.flight_details?.[index]?.Airline && (
                        <p className="errormessage">
                          {errors.flight_details[index].Airline.message}
                        </p>
                      )}
                    </div>

                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Flight Number (digits only)
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`flight_details[${index}].flight_number`}
                        control={control}
                        rules={{
                          required: "Flight Number is Required",
                          validate: (value) => {
                            if (!/^[a-zA-Z0-9]+$/.test(value)) {
                              return "Only letters and numbers are allowed";
                            }
                            if (value.length > 10) {
                              // Change to 7 if needed
                              return "Maximum 10 characters allowed";
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter flight number"
                            type="text"
                            value={flight.flight_number}
                            maxLength={10}
                            onChange={(e) => {
                              // Allow only alphanumeric, convert to uppercase (standard for flight numbers)
                              const cleanedValue = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );

                              // Prevent exceeding max length
                              const truncatedValue = cleanedValue.slice(0, 10); // Change to 7 if needed

                              const updatedFlightDetails = [...flightDetails];
                              updatedFlightDetails[index].flight_number =
                                truncatedValue;
                              setFlightDetails(updatedFlightDetails);
                              setTriggerFrom("original");

                              field.onChange(truncatedValue);
                              setFormValue(
                                `flight_details[${index}].flight_number`,
                                truncatedValue
                              );






                              // debounce the "trigger" call so it fires only after typing stops
                              if (typingTimeouts.current[index]) {
                                clearTimeout(typingTimeouts.current[index]);
                              }
                              typingTimeouts.current[index] = setTimeout(() => {

                                if (truncatedValue.length > 0) {

                                  setTriggerIndex(index);

                                } else {
                                  setTriggerIndex(null);
                                }

                                // any other action that should run after typing stops
                                delete typingTimeouts.current[index];
                              }, DEBOUNCE_MS);


                            }}
                          />
                        )}
                      />
                      {errors.flight_details?.[index]?.flight_number && (
                        <p className="errormessage">
                          {errors.flight_details[index].flight_number.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="grid-two">
                    <div className="custom-date-time-container">
                      <label className="custom-date-time-label">
                        Scheduled departure date & time{" "}
                        <span style={{ color: "#de8385" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <div className="custom-date-time-box">
                          <Controller
                            name={`flight_details[${index}].date_of_travel`}
                            control={control}
                            defaultValue={flight.date_of_travel}
                            rules={{
                              required: "Travel Date is required",
                              validate: validateDateFormat,
                            }}
                            render={({ field }) => (
                              <CustomDOBPicker
                                {...field}
                                error={
                                  errors.flight_details?.[index]?.date_of_travel
                                    ?.message || departureDateError
                                }

                                inputRequired={true}
                                placeholder="Choose date"
                                inputClassName="custom-date-input"
                                onChange={(value) => {
                                  field.onChange(value);

                                  // Custom logic
                                  setDepartureDateError(null);
                                  const updatedFlightDetails = [
                                    ...flightDetails,
                                  ];
                                  updatedFlightDetails[index].date_of_travel =
                                    value;
                                  setFlightDetails(updatedFlightDetails);
                                  setFormValue(
                                    `flight_details[${index}].date_of_travel`,
                                    value
                                  );
                                  setTriggerIndex(index);
                                  setTriggerFrom("original");
                                }}
                              />
                            )}
                          />

                          <Controller
                            name={`flight_details[${index}].original_departure_time`}
                            control={control}
                            defaultValue={flight.original_departure_time}
                            rules={{
                              required: "Departure Time is required",
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                ref={timeRef}
                                disabled={flight?.manual !== true}

                                type={flight.original_departure_time === "" ? "text" : "time"}
                                onFocus={() => setTimeInputType("time")}
                                onBlur={() => setTimeInputType("text")}
                                placeholder="Time"
                                className="custom-time-input"
                                required
                                onChange={(e) => {
                                  const timeVal = e.target.value;
                                  field.onChange(timeVal);

                                  setDepartureDateError(null);
                                  const updatedFlightDetails = [
                                    ...flightDetails,
                                  ];
                                  updatedFlightDetails[
                                    index
                                  ].original_departure_time = timeVal;
                                  setFlightDetails(updatedFlightDetails);
                                  setFormValue(
                                    `flight_details[${index}].original_departure_time`,
                                    timeVal
                                  );
                                  setTriggerIndex(null);
                                }}
                              />
                            )}
                          />
                        </div>{" "}
                      </div>

                      {(errors.flight_details?.[index]?.date_of_travel ||
                        errors.flight_details?.[index]
                          ?.original_departure_time) && (
                          <p className="errormessage">
                            {errors.flight_details?.[index]?.date_of_travel
                              ?.message ||
                              errors.flight_details?.[index]
                                ?.original_departure_time?.message ||
                              "Travel Date and Time is Required"}
                          </p>
                        )}
                    </div>

                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Airport of origin
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                        {flightOptions[index] &&
                          flightOptions[index].length > 0 ? (
                          <div style={{ width: "100%" }}>
                            {/* <div>Coming in if</div> */}
                            <Controller
                              name={`flight_details[${index}].airport_of_origin`}
                              control={control}
                              rules={{
                                required: "Origin airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  isDisabled={flight?.manual !== true}
                                  cacheOptions
                                  // defaultOptions={flightOptions[index].map(
                                  //   (option) => ({
                                  //     value: option.departure.airport,
                                  //     arrival: option.arrival.airport,
                                  //     departure: option.departure.airport,
                                  //     label: `${option.departure.airport} (${option.departure.iata}) - ${option.arrival.airport} (${option.arrival.iata})`,
                                  //   })
                                  // )}
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  value={
                                    flight.airport_of_origin
                                      ? {
                                        label: flight.departure_iata_code
                                          ? flight.airport_of_origin.includes(
                                            "("
                                          ) // Check if "(" exists
                                            ? flight.airport_of_origin // Keep original if it has parentheses
                                            : `${flight.airport_of_origin} (${flight.departure_iata_code})` // Else, append IATA
                                          : flight.airport_of_origin, // No IATA code? Show as-is
                                        value: flight.airport_of_origin,
                                      }
                                      : null
                                  }
                                  placeholder="Select Origin Airport"
                                  onChange={(selectedOption) => {
                                    setTriggerIndex(null);
                                    const updatedFlightDetails = [
                                      ...flightDetails,
                                    ];
                                    updatedFlightDetails[
                                      index
                                    ].airport_of_origin =
                                      selectedOption?.label || "";
                                    setFlightDetails(updatedFlightDetails);
                                    field.onChange(selectedOption?.label || "");
                                    setFormValue(
                                      `flight_details[${index}].airport_of_origin`,
                                      selectedOption?.label || ""
                                    );
                                  }}
                                />
                              )}
                            />

                          </div>
                        ) : (
                          <div style={{ width: "100%" }}>
                            {/* <div>Coming in else</div> */}
                            <Controller
                              name={`flight_details[${index}].airport_of_origin`}
                              control={control}
                              defaultValue={flight.airport_of_origin}
                              rules={{
                                required: "Origin airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  isDisabled={flight?.manual !== true}
                                  value={
                                    flight.airport_of_origin
                                      ? {
                                        label: flight.airport_of_origin,
                                        value: flight.airport_of_origin,
                                      }
                                      : null
                                  }
                                  placeholder="Select Origin Airport"
                                  onChange={(selectedOption) => {
                                    setTriggerIndex(null);
                                    const updatedFlightDetails = [
                                      ...flightDetails,
                                    ];
                                    updatedFlightDetails[
                                      index
                                    ].airport_of_origin =
                                      selectedOption?.label || "";
                                    setFlightDetails(updatedFlightDetails);
                                    field.onChange(selectedOption?.label || "");
                                    setFormValue(
                                      `flight_details[${index}].airport_of_origin`,
                                      selectedOption?.label || ""
                                    );
                                  }}
                                />
                              )}
                            />



                          </div>
                        )}
                      </div>

                      {errors.flight_details?.[index]
                        ?.airport_of_origin && (
                          <p className="errormessage">
                            {
                              errors.flight_details[index].airport_of_origin
                                .message
                            }
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="grid-two">
                    <div className="custom-date-time-container">
                      <label className="custom-date-time-label">
                        Scheduled arrival date & time{" "}
                        <span style={{ color: "#de8385" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <div className="custom-date-time-box">
                          <Controller
                            name={`flight_details[${index}].original_arrival_date`}
                            control={control}
                            defaultValue={flight.original_arrival_date}
                            rules={{
                              required: "Arrival Date is required",
                              validate: validateDateFormat,
                            }}
                            render={({ field }) => (
                              <CustomDOBPicker
                                {...field}
                                error={
                                  errors.flight_details?.[index]
                                    ?.original_arrival_date?.message ||
                                  dateError
                                }
                                disabled={flight?.manual !== true}

                                inputRequired={true}
                                placeholder="Choose date"
                                inputClassName="custom-date-input"
                                onChange={(value) => {
                                  field.onChange(value);
                                  setDateError(null);
                                  const updatedFlightDetails = [
                                    ...flightDetails,
                                  ];
                                  updatedFlightDetails[
                                    index
                                  ].original_arrival_date = value;
                                  setFlightDetails(updatedFlightDetails);
                                  setFormValue(
                                    `flight_details[${index}].original_arrival_date`,
                                    value
                                  );
                                  setTriggerIndex(null);
                                }}
                              />
                            )}
                          />

                          <Controller
                            name={`flight_details[${index}].original_arrival_time`}
                            control={control}
                            defaultValue={flight.original_arrival_time}
                            rules={{
                              required: "Arrival Time is required",
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                ref={timeRef}
                                type={flight.original_arrival_time === "" ? "text" : "time"}
                                onFocus={() => setTimeInputType2("time")}
                                onBlur={() => setTimeInputType2("text")}
                                placeholder="Time"
                                className="custom-time-input"
                                required


                                disabled={flight?.manual !== true}

                                onChange={(e) => {
                                  const newTime = e.target.value;
                                  field.onChange(newTime);
                                  setDateError(null);
                                  const updatedFlightDetails = [
                                    ...flightDetails,
                                  ];
                                  updatedFlightDetails[
                                    index
                                  ].original_arrival_time = newTime;
                                  setFlightDetails(updatedFlightDetails);
                                  setFormValue(
                                    `flight_details[${index}].original_arrival_time`,
                                    newTime
                                  );
                                  setTriggerIndex(null);
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                      {/* {dateError && (
                        <div
                          className="error-message"
                          style={{ color: "red", marginTop: "5px" }}
                        >
                          {dateError}
                        </div>
                      )} */}
                      {(errors.flight_details?.[index]?.original_arrival_date ||
                        errors.flight_details?.[index]
                          ?.original_arrival_time) && (
                          <p className="errormessage">
                            {errors.flight_details?.[index]?.original_arrival_date
                              ?.message ||
                              errors.flight_details?.[index]
                                ?.original_arrival_time?.message ||
                              "Arrival Date and Time is Required"}
                          </p>
                        )}
                    </div>
                    <div className="custom-select" style={{ width: "100%" }}>
                      <span className="select-label">
                        Airport of destination{" "}
                        <span style={{ color: "#de8385" }}> *</span>
                      </span>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                        {flightOptions[index] &&
                          flightOptions[index].length > 0 ? (
                          <div style={{ width: "100%" }}>
                            <Controller
                              name={`flight_details[${index}].airport_of_destination`}
                              control={control}
                              rules={{
                                required: "Destination airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  isDisabled={flight?.manual !== true}

                                  defaultOptions={defaultOptions}
                                  value={
                                    flight.airport_of_destination
                                      ? {
                                        label: flight.arrival_iata_code
                                          ? flight.airport_of_destination.includes(
                                            "("
                                          ) // Check if "(" exists
                                            ? flight.airport_of_destination // Keep original if it already has parentheses
                                            : `${flight.airport_of_destination} (${flight.arrival_iata_code})` // Else, append IATA
                                          : flight.airport_of_destination, // No IATA code? Show as-is
                                        value: flight.airport_of_destination,
                                      }
                                      : null
                                  }
                                  placeholder="Select Destination Airport"
                                  onChange={(selectedOption) => {
                                    setTriggerIndex(null);
                                    const updatedFlightDetails = [
                                      ...flightDetails,
                                    ];
                                    updatedFlightDetails[
                                      index
                                    ].airport_of_destination =
                                      selectedOption?.label || "";
                                    setFlightDetails(updatedFlightDetails);
                                    field.onChange(selectedOption?.label || "");
                                    setFormValue(
                                      `flight_details[${index}].airport_of_destination`,
                                      selectedOption?.label || ""
                                    );
                                  }}
                                  styles={selectStyles}
                                />
                              )}
                            />

                          </div>
                        ) : (
                          <div style={{ width: "100%" }}>
                            <Controller
                              name={`flight_details[${index}].airport_of_destination`}
                              control={control}
                              defaultValue={flight.airport_of_destination}
                              rules={{
                                required: "Destination airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  isDisabled={flight?.manual !== true}

                                  defaultOptions={defaultOptions}
                                  value={
                                    flight.airport_of_destination
                                      ? {
                                        label: flight.airport_of_destination,
                                        value: flight.airport_of_destination,
                                      }
                                      : null
                                  }
                                  placeholder="Select Destination Airport"
                                  onChange={(selectedOption) => {
                                    setTriggerIndex(null);
                                    const updatedFlightDetails = [
                                      ...flightDetails,
                                    ];
                                    updatedFlightDetails[
                                      index
                                    ].airport_of_destination =
                                      selectedOption?.label || "";
                                    setFlightDetails(updatedFlightDetails);
                                    field.onChange(selectedOption?.label || "");
                                    setFormValue(
                                      `flight_details[${index}].airport_of_destination`,
                                      selectedOption?.label || ""
                                    );
                                  }}
                                  styles={selectStyles}
                                />
                              )}
                            />


                          </div>
                        )}
                      </div>

                      {errors.flight_details?.[index]
                        ?.airport_of_destination && (
                          <p className="errormessage">
                            {
                              errors.flight_details[index]
                                .airport_of_destination.message
                            }
                          </p>
                        )}



                    </div>
                  </div>
                  <div className="grid-two">
                    {/* <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Ticket reference (PNR code)
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`flight_details[${index}].ticket_ref_no`}
                        control={control}
                        rules={{
                          required: "PNR code is required",
                          validate: (value) => {
                            if (!/^[a-zA-Z0-9]+$/.test(value)) {
                              return "Only letters and numbers are allowed";
                            }
                            if (value.length < 6) {
                              return "Minimum 6 characters required";
                            }
                            if (value.length > 10) {
                              return "Maximum 10 characters allowed";
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="ABC123"
                            type="text"
                            value={flight.ticket_ref_no}
                            maxLength={10} // Hard limit in UI
                            onChange={(e) => {
                              // Allow only alphanumeric, convert to uppercase (standard for PNRs)
                              const cleanedValue = e.target.value
                                .replace(/[^a-zA-Z0-9]/g, "")
                                .toUpperCase();

                              // Prevent exceeding max length
                              const truncatedValue = cleanedValue.slice(0, 10);

                              const updatedFlightDetails = [...flightDetails];
                              updatedFlightDetails[index].ticket_ref_no =
                                truncatedValue;
                              setFlightDetails(updatedFlightDetails);
                              // setTriggerIndex(index);
                              // setTriggerFrom("original");
                              field.onChange(truncatedValue);
                              setFormValue(
                                `flight_details[${index}].ticket_ref_no`,
                                truncatedValue
                              );
                            }}
                          />
                        )}
                      />
                      {errors.flight_details?.[index]?.ticket_ref_no && (
                        <p className="errormessage">
                          {errors.flight_details[index].ticket_ref_no.message}
                        </p>
                      )}
                    </div> */}
                    <div className="custom-select" style={{ width: "100%" }}>
                      <span className="select-label">
                        Flight class{" "}
                        <span style={{ color: "#de8385" }}> *</span>
                      </span>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                        <Controller
                          name={`flight_details[${index}].flight_class`}
                          control={control}
                          // rules={{ required: false }}
                          defaultValue={'Economy'}
                          render={({ field }) => (
                            <AsyncSelect
                              {...field}
                              cacheOptions
                              loadOptions={(val, callback) => {
                                callback(
                                  flightClassOptions.filter((option) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(val.toLowerCase())
                                  )
                                );
                              }}
                              defaultOptions={flightClassOptions}
                              value={


                                flight.flight_class
                                  ? flightClassOptions.find(
                                    (opt) => opt.value === flight.flight_class
                                  )
                                  : null


                              }
                              placeholder="Select class"
                              onChange={(selectedOption) => {
                                const value = selectedOption?.value || "";
                                const updatedFlightDetails = [...flightDetails];
                                updatedFlightDetails[index].flight_class =
                                  value;
                                setFlightDetails(updatedFlightDetails);
                                field.onChange(value);
                                setFormValue(
                                  `flight_details[${index}].flight_class`,
                                  value
                                );
                              }}
                              styles={selectStyles}
                            />
                          )}
                        />
                      </div>
                      {errors.flight_details?.[index]?.flight_class && (
                        <p className="errormessage">
                          {errors.flight_details[index].flight_class.message}
                        </p>
                      )}
                    </div>
                    <div className="custom-input">

                      <label className="input-label">Flight info didn't appear ?</label>
                      <button className="btn btn-manual" type="button" onClick={() => {
                        setManualEntryIndex(index);
                      }} >

                        enter manually

                      </button>

                    </div>

                  </div>
                  {type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages" ? (
                    <>
                      <h2
                        className="stepper-sub-header"
                        style={{ marginBottom: "15px", marginTop: "15px" }}
                      >
                        What was the issue with this flight?
                      </h2>

                      <div className="radio-btn-wrapper">
                        <Controller
                          name={`flight_details[${index}].disruption`}
                          control={control}
                          // rules={{ required: "Please select an issue" }}
                          render={({ field }) => (
                            <>
                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`delay_${index}`}
                                  value="delayed"
                                  checked={field.value === "delayed"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "delayed",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`delay_${index}`}>
                                  Flight delayed
                                </label>
                              </div>

                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`cancel_${index}`}
                                  value="cancelled"
                                  checked={field.value === "cancelled"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "cancelled",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`cancel_${index}`}>
                                  Flight canceled
                                </label>
                              </div>

                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`miss_${index}`}
                                  value="missed"
                                  checked={field.value === "missed"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "missed",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`miss_${index}`}>
                                  Missed Connection
                                </label>
                              </div>

                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`denied_${index}`}
                                  value="denied"
                                  checked={field.value === "denied"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "denied",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`denied_${index}`}>
                                  Denied Boarding
                                </label>
                              </div>


                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`downgraded_${index}`}
                                  value="downgraded"
                                  checked={field.value === "downgraded"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "downgraded",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`downgraded_${index}`}>
                                  Downgraded
                                </label>
                              </div>

                              <div
                                className="radio-input-wrapper"
                                style={{ width: "100%", maxWidth: "fit-content" }}
                              >
                                <input
                                  type="radio"
                                  id={`none_${index}`}
                                  value="none"
                                  checked={field.value === "none"}
                                  onChange={() =>
                                    handleDisruptionChange(
                                      index,
                                      "none",
                                      field.onChange
                                    )
                                  }
                                />
                                <label htmlFor={`none_${index}`}>
                                  None of these
                                </label>
                              </div>
                            </>
                          )}
                        />
                      </div>


                      {errors.flight_details?.[index]?.disruption && (
                        <p className="errormessage">
                          {errors.flight_details[index].disruption.message}
                        </p>
                      )}

                      <h4
                        className="stepper-sub-sub-header"
                        style={{ marginBottom: "15px", marginTop: "15px" }}
                      >
                        {watchedDisruptions[index] === "delayed"
                          ? "How long was your delay? "
                          : watchedDisruptions[index] === "cancelled"
                            ? "When were you informed about the cancellation? Before or at the airport? "
                            : watchedDisruptions[index] === "missed"
                              ? "Why did you miss your flight? "
                              : ""}
                      </h4>

                      {watchedDisruptions[index] === "delayed" ? (
                        <>
                          <div className="radio-btn-wrapper">
                            <Controller
                              name={`flight_details[${index}].delay_duration`}
                              control={control}
                              // rules={{
                              //   required: "Please select delay duration",
                              // }}
                              render={({ field }) => (
                                <>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`delay_less_than_3_${index}`}
                                      value="179"
                                      checked={field.value === "179"}
                                      onChange={() =>
                                        handleDelayedonChange(
                                          index,
                                          "179",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`delay_less_than_3_${index}`}
                                    >
                                      Less than 3 hours
                                    </label>
                                  </div>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`delay_3_to_4_${index}`}
                                      value="181"
                                      checked={field.value === "181"}
                                      onChange={() =>
                                        handleDelayedonChange(
                                          index,
                                          "181",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label htmlFor={`delay_3_to_4_${index}`}>
                                      3–4 hours
                                    </label>
                                  </div>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`delay_4_plus_${index}`}
                                      value="241"
                                      checked={field.value === "241"}
                                      onChange={() =>
                                        handleDelayedonChange(
                                          index,
                                          "241",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label htmlFor={`delay_4_plus_${index}`}>
                                      4+ hours
                                    </label>
                                  </div>

                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`delay_none_${index}`}
                                      value="none"
                                      checked={field.value === "none"}
                                      onChange={() =>
                                        handleDelayedonChange(
                                          index,
                                          "none",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label htmlFor={`delay_none_${index}`}>
                                      None of these
                                    </label>
                                  </div>
                                </>
                              )}
                            />
                          </div>

                          {errors.flight_details?.[index]?.delay_duration && (
                            <p className="errormessage">
                              {
                                errors.flight_details[index].delay_duration
                                  .message
                              }
                            </p>
                          )}
                        </>
                      ) : watchedDisruptions[index] === "cancelled" ? (
                        <>
                          <div className="radio-btn-wrapper">
                            <Controller
                              name={`flight_details[${index}].flight_cancel`}
                              control={control}
                              // rules={{
                              //   required: "Please select any of the option",
                              // }}
                              render={({ field }) => (
                                <>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`cancellation_info_before_${index}`}
                                      value="cancellation_info_before"
                                      checked={
                                        field.value ===
                                        "cancellation_info_before"
                                      }
                                      onChange={() =>
                                        handleCancellationonChange(
                                          index,
                                          "cancellation_info_before",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`cancellation_info_before_${index}`}
                                    >
                                      Before arriving at the airport
                                    </label>
                                  </div>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`cancellation_info_at_airport_${index}`}
                                      value="cancellation_info_at_airport"
                                      checked={
                                        field.value ===
                                        "cancellation_info_at_airport"
                                      }
                                      onChange={() =>
                                        handleCancellationonChange(
                                          index,
                                          "cancellation_info_at_airport",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`cancellation_info_at_airport_${index}`}
                                    >
                                      At the airport
                                    </label>
                                  </div>

                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`cancellation_none_${index}`}
                                      value="none"
                                      checked={
                                        field.value ===
                                        "none"
                                      }
                                      onChange={() =>
                                        handleCancellationonChange(
                                          index,
                                          "none",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`cancellation_none_${index}`}
                                    >
                                      None of these
                                    </label>
                                  </div>
                                </>
                              )}
                            />
                          </div>
                          {errors.flight_details?.[index]?.flight_cancel && (
                            <p className="errormessage">
                              {
                                errors.flight_details[index].flight_cancel
                                  .message
                              }
                            </p>
                          )}
                        </>
                      ) : watchedDisruptions[index] === "missed" ? (
                        <>
                          <div className="radio-btn-wrapper">
                            <Controller
                              name={`flight_details[${index}].missed_connection`}
                              control={control}
                              // rules={{
                              //   required:
                              //     "Please select miss connection reason",
                              // }}
                              render={({ field }) => (
                                <>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`missed_due_to_error_${index}`}
                                      value="missed_due_to_error"
                                      checked={
                                        field.value === "missed_due_to_error"
                                      }
                                      onChange={() =>
                                        handleMissedonChange(
                                          index,
                                          "missed_due_to_error",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`missed_due_to_error_${index}`}
                                    >
                                      Airline action
                                    </label>
                                  </div>
                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`missed_due_to_personal_${index}`}
                                      value="missed_due_to_personal"
                                      checked={
                                        field.value === "missed_due_to_personal"
                                      }
                                      onChange={() =>
                                        handleMissedonChange(
                                          index,
                                          "missed_due_to_personal",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`missed_due_to_personal_${index}`}
                                    >
                                      Personal reasons
                                    </label>
                                  </div>

                                  <div
                                    className="radio-input-wrapper"
                                    style={{ width: "100%", maxWidth: "fit-content" }}
                                  >
                                    <input
                                      type="radio"
                                      id={`missed_none_${index}`}
                                      value="none"
                                      checked={
                                        field.value === "none"
                                      }
                                      onChange={() =>
                                        handleMissedonChange(
                                          index,
                                          "none",
                                          field.onChange
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`missed_none_${index}`}
                                    >
                                      None of these
                                    </label>
                                  </div>
                                </>
                              )}
                            />
                          </div>
                          {errors.flight_details?.[index]
                            ?.missed_connection && (
                              <p className="errormessage">
                                {
                                  errors.flight_details[index].missed_connection
                                    .message
                                }
                              </p>
                            )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : null}

                  <div style={{ marginTop: "30px" }}>
                    <h4 className="stepper-sub-header">Additional details</h4>
                    <Controller
                      name={`flight_details[${index}].additional_details`}
                      control={control}
                      render={({ field }) => (
                        <textarea
                          {...field}
                          style={{ marginTop: "20px" }}
                          rows={8}
                          placeholder="Add any relevant details about your delayed flight"
                          onChange={(e) => {
                            const updatedFlightDetails = [...flightDetails];
                            updatedFlightDetails[index].additional_details =
                              e.target.value;
                            setFlightDetails(updatedFlightDetails);
                            // setTriggerIndex(index);
                            // setTriggerFrom("original");
                            setFormValue(
                              `flight_details[${index}].additional_details`,
                              e.target.value
                            );
                          }}
                        />
                      )}
                    />
                  </div>

                  {/* <p style={{ marginTop: '10px', color: '#f23939' }}>If this was part of a connecting flight  journey, please enter the next flight in order</p> */}
                </div>
              ))}
          </div>
        </div>
      </form>
    </div>
  );
};

export default OriginallyBookedFlights;
